import React, { useEffect, useState } from "react";
// import Tabs from './tabs';
import "./css.css";
import img1 from "../img/JYNT_1D.png";
import img2 from "../img/JYNT_1M.png";
import img3 from "../img/JYNT_1Y.png";
import { useNavigate } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Button from "react-bootstrap/Button";
// import Form from "react-bootstrap/Form";
import { db } from "../config_firebase";
import * as Yup from "yup";
import { Formik, Field, Form } from "formik";
import { Form as Form1 } from "react-bootstrap";

import {
  collection,
  addDoc,
  getDocs,
  doc,
} from "firebase/firestore";

/**
 * @author
 * @function
 **/

export const Page3A = (props) => {
  const [pic, setPic] = useState(img1);
  const [estimation, setConfidence] = useState(true);
  const history = useNavigate();
  const [url, setUrl] = useState(window.location.href);
  const [userId, setUserId] = useState("");
  const [key, setKey] = useState('page3A_1D');
  const [random_group, setNum] = useState("");
  const [selectedValue, setSelectedValue] = useState(50);
  const [isRangeMoved, setIsRangeMoved] = useState(false);

  const handleRangeChange = (event) => {
    setSelectedValue(event.target.value);
  };

  async function addclick(data) {
    console.log(data);
    const docRef = await addDoc(collection(db, "clicksdata"), {data,});
  }

  const submit = async () => {
    console.log(selectedValue);
    localStorage.setItem("page3A_confidence",selectedValue);
    const page3A_confidence_button = {
      time: Date.now(),
      userId: localStorage.getItem("user_id"),
      buttonType: "page3A_confidence_button",
    };
    var parsedArray = JSON.parse(localStorage.getItem("random_array"));
    if (parsedArray.length>0)
    {
      history(`/transition/?,${userId}`);
    }
    else{
      history(`/questionnaire/?,${userId}`);
    }
    addclick(page3A_confidence_button);
  }

  const button = async (eventKey) => {
    setKey(eventKey)
    const clickdata = {
      time: Date.now(),
      userId: localStorage.getItem("user_id"),
      buttonType: eventKey,
    };
    addclick(clickdata);
    if (eventKey === "page3A_1D") {
      setPic(img1);
    }
    if (eventKey === "page3A_1M") {
      setPic(img2);
    }
    if (eventKey === "page3A_1Y") {
      setPic(img3);
    }
  }

  useEffect(() => {
    const iosa = url.split(",");
    setUserId(iosa[1]);
  }, []);

  useEffect(() => {
    const random_group = localStorage.getItem("random_group");
    console.log(random_group);
    setNum(random_group);
  }, []);
  
  return (
    <div className="main">
      <div className="header">
        <h1>CORPORATION Z</h1>
        <h3>Current Price: 18.47 USD</h3>
      </div>
      <div className="grid">
        <div className="webtabs">
          <Tabs
            defaultActiveKey="profile" id="uncontrolled-tab-example" className="mb-3" activeKey={key}
            onSelect={(e) => button(e)}
          >
            <Tab eventKey="page3A_1D" title="1D">
              <img className="img" src={pic} alt="" />
            </Tab>
            <Tab eventKey="page3A_1M" title="1M">
              <img className="img" src={pic} alt="" />
            </Tab>
            <Tab eventKey="page3A_1Y" title="1Y">
              <img className="img" src={pic} alt="" />
            </Tab>
            <Tab eventKey="page3A_details" title="Details">
              {/* <img className="img1" src={pic} alt="" /> */}
              <table class="table table-hover table-dark table-striped">
                <tbody>
                  <tr>
                    <th scope="row"></th>
                    <td>Open</td>
                    <td>19.5</td>
                    <td>Beta</td>
                    <td>1.65</td>
                  </tr>
                  <tr>
                    <th scope="row"></th>
                    <td>High</td>
                    <td>19.75</td>
                    <td>Avg Volume</td>
                    <td>139666.67</td>
                  </tr>
                  <tr>
                    <th scope="row"></th>
                    <td>Low</td>
                    <td>18.25</td>
                    <td>Market Cap</td>
                    <td>2449893</td>
                  </tr>
                  <tr>
                    <th scope="row"></th>
                    <td>Close</td>
                    <td>18.47</td>
                    <td>52 Week High</td>
                    <td>19.81</td>
                  </tr>
                  <tr>
                    <th scope="row"></th>
                    <td>Adj Close</td>
                    <td>18.47</td>
                    <td>52 Week Low</td>
                    <td>6.51</td>
                  </tr>
                  <tr>
                    <th scope="row"></th>
                    <td>Volume</td>
                    <td>216800</td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </Tab>
            <Tab eventKey="page3A_profile" title="Profile">
              {/* <img className="img" src={pic} alt="" /> */}
              <p className="profileinfo"> Sector: Health Care <br></br><br></br>
                This corporation owns and manages chiropractic medical centers. <br></br> 
                The two main domains of the corporation are firm clinics and franchise procedures. <br></br>
                The corporation operates via outright ownership, management contracts, granting franchises, and regional pioneers.
              </p>
            </Tab>
          </Tabs>
        </div>
        <div className="info">

        {estimation ? (
              <div class="text-center">
                <h1 className="rec">RECOMMENDATION</h1>
                { random_group.includes("1") ? (
                  <p>
                    The following recommendation was provided by a stock market expert.
                    In earlier prediction tasks, the expert achieved a success rate of 50%.<br></br>
                    <span className="recommendation">The recommendation: </span> <br></br>
                    A month later, the value of the stock will be $16.70.<br></br> 
                  </p>
                ) : random_group.includes("2") ? (
                  <p>
                    The following recommendation was provided by a stock market expert.
                    In earlier prediction tasks, the expert achieved a success rate of 90%.<br></br>
                    <span className="recommendation">The recommendation: </span> <br></br>
                    A month later, the value of the stock will be $16.70.<br></br> 
                  </p>
                ) : random_group.includes("3") ? (
                  <p>
                    The following recommendation was provided by an AI algorithm.
                    In earlier prediction tasks, the algorithm achieved a success rate of 50%.<br></br>
                    <span className="recommendation">The recommendation: </span> <br></br>
                    A month later, the value of the stock will be $16.70.<br></br> 
                  </p>
                ) : (
                  <p>
                    The following recommendation was provided by an AI algorithm.
                    In earlier prediction tasks, the algorithm achieved a success rate of 90%.<br></br>
                    <span className="recommendation">The recommendation: </span> <br></br>
                    A month later, the value of the stock will be $16.70.<br></br> 
                  </p>
                )    
              }
              <h1 className="finalpred">YOUR FINAL PREDICTION</h1>
              <p>Based on the information available, what is your prediction of the stock's price, in $, exactly one month later?</p>
            <Formik
              initialValues={{ page3A_prediction: "" }}
              onSubmit={(values) => {
                // values.preventDefault();
                console.log(values.page3A_prediction);
                localStorage.setItem("page3A_prediction", values.page3A_prediction);
                const page3A_prediction_button = {
                  time: Date.now(),
                  userId: localStorage.getItem("user_id"),
                  buttonType: "page3A_prediction_button",
                };
                addclick(page3A_prediction_button);
                setConfidence(false);
              }}
              validationSchema={Yup.object({
                page3A_prediction: Yup.number().max(10000).min(0).required("prediction is required"),
              })}
            >
              {(formik, isSubmitting) => (
                <Form>
                  <div className="d-flex justify-content-center">
                    <div className="col-sm-4">
                      <Field name="page3A_prediction" className={formik.touched.page3A_prediction && formik.errors.page3A_prediction ? "form-control is-invalid" : "form-control"} type="text" placeholder="numbers only"/>
                    </div>
                  </div>
<br></br>
                  <div class="text-center">
                    <Button variant="dark" className="estbutton" type="submit">Submit</Button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
          ) : (
            <div class="text-center">
              <div>
                <h1>YOUR CONFIDENCE LEVEL</h1>
                <p> Please move the marker to indicate how confident you are that your prediction is accurate, from 0 to 100. 
                  <span className="marker_span"><br></br>0- I am definitely wrong.
                  100- I am definitely right. </span><br></br>
                </p>
              </div>
              <Form1.Range name="page3A_confidence" value={selectedValue} onChange={handleRangeChange} onInput={() => setIsRangeMoved(true)}/>
              <p>Confidence level: {isRangeMoved ? selectedValue : "none"}</p>
              <Button variant="dark" className="estbutton" type="submit" onClick={submit} disabled={!isRangeMoved}>Submit</Button>
            </div>   
          )}
        </div>
      </div>
    </div>
  );
};
